import { memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import {
  BreadCrumb,
  BreadCrumbs,
  BreadCrumbsSizesMD,
  BreadCrumbsSizesSM,
} from '@picsart/design-system/components/BreadCrumbs';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import useDevice from 'hooks/useDeviceType';
import useCategoryDataStore from 'templates/stores/categoryDataStore';
import getTemplatesNavigationData from 'utils/getTemplatesNavigationData';
import useStyles from './styles';
import { breadCrumbsInitialData, TEMPLATE_HUB_URL } from '../../pages/Categories/constants';

const TopNavigation = () => {
  const classes = useStyles();
  const isMobile = useDevice();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [query] = useSearchParams();

  const { categoryData } = useCategoryDataStore(state => ({
    categoryData: state.category,
  }));

  const { breadCrumbsData } = useMemo(
    () => getTemplatesNavigationData({ query, selectedCategory: categoryData }),
    [query, categoryData],
  );

  const redirect = useCallback(
    (index: number) => {
      const nextSegment = pathname.split('/')[index + 1];
      const url =
        nextSegment === breadCrumbsInitialData[0].name
          ? `${TEMPLATE_HUB_URL}/`
          : `${TEMPLATE_HUB_URL}/${nextSegment}`;

      navigate(url);
    },
    [navigate, pathname],
  );

  return (
    <HorizontalContainer>
      <BreadCrumbs
        className={classes.root}
        size={isMobile ? BreadCrumbsSizesSM : BreadCrumbsSizesMD}
      >
        {breadCrumbsData.map((el, index) => (
          <BreadCrumb
            onClick={index === breadCrumbsData.length - 1 ? null : () => redirect(index)}
            isActive={index === breadCrumbsData.length - 1}
            key={el.name}
            data-testid="top-navigation-item"
          >
            {`${el.title || el.display_name}`}
          </BreadCrumb>
        ))}
      </BreadCrumbs>
    </HorizontalContainer>
  );
};

export default memo(TopNavigation);
